import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'input',
      label: '标题',
      placeholder: '请输入标题'
    },
    {
      field: 'content',
      type: 'input',
      label: '内容',
      placeholder: '请输入内容'
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '筛选日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          const sixMonthsAgo = new Date();
          sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
          return date.getTime() < sixMonthsAgo.getTime();
        }
      }
    }
  ]
}

